import type { HorizontalBarDatum } from '@/components/charts/HorizontalBarChart';
import type { ChartCategoryPoint } from '@/models/ServiceTypes';

/**
 * Converts an API category series into the bar chart's datum shape.
 *
 * `order` is optional on the wire: the onboarding endpoint omits it and relies
 * on the order it emits points in, while the frequency and recency endpoints
 * set it. Sorting by `order ?? 0` would collapse an unordered series into one
 * arbitrary tie, so a series that never carries `order` keeps the order the API
 * chose.
 */
export function toChartData(
  points: ChartCategoryPoint[],
  resolveName: (point: ChartCategoryPoint) => string = (point) => point.name,
): HorizontalBarDatum[] {
  const ordered = points.every((point) => point.order === undefined)
    ? points
    : [...points].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return ordered.map((point) => ({
    id: point.id,
    name: resolveName(point),
    rawValue: point.y,
    percentValue: point.percent,
  }));
}
